<template>
  <div class="layout text-white h-full bg-bg-1 flex schedule-plan">
    <template v-if="dataLoaded">
      <div class="flex flex-col px-32 py-20 w-full">
        <div class="flex flex-row justify-between">
          <p class="text-20 font-medium leading-snug">{{ $t(detail.name || '') }}</p>
          <Button
            @click="importPlan"
            type="primary"
            class="ml-10"
            :loading="loading"
          >
            {{ $t(`R1111`) }}</Button
          >
        </div>
        <div class="mt-16 flex flex-row">
          <Textarea
            class="schedule-overview-textarea border border-dark-60 color-white"
            maxlength="800"
            disabled
            :show-word-limit="true"
            :auto-size="false"
            :model-value="$t(detail.overview)"
          >
          </Textarea>
        </div>
        <ScheduleChart
          mode="share"
          :chartData="chartData"
        ></ScheduleChart>
        <div class="flex-1 flex flex-col mt-45 w-full overflow-y-hidden">
          <Table
            class="coros-calender w-full flex-1 overflow-y-hidden"
            :stripe="false"
            :pagination="false"
            :bordered="tableBorder"
            :hoverable="false"
            :columns="columns"
            :data="chunkDays"
            @open-edit-modal="handleOpenEditModal"
            :readonly="true"
            from="plan"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <SkeletonPage></SkeletonPage>
    </template>
    <!-- 拉取到用户信息后再初始化 -->
    <template v-if="dataLoaded">
      <TrainingEdit
        :showModal="showPlanModal"
        :training-program="trainingForm"
        :operate-type="operateType"
        @on-cancel="handleCancel"
        from="plan"
        :readonly="true"
      ></TrainingEdit>
      <ProgramEdit
        v-model:visible="showProgramModal"
        :team-id="teamId"
        :program-info="program2edit"
        :operate-type="operateType"
        @on-cancel="handleProgramModalChange"
        from="plan"
        :readonly="true"
      ></ProgramEdit>
    </template>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { Textarea, Button, Modal, Message } from '@arco-design/web-vue';
import Table from '@client/pages/personal/schedule/calender/table.vue';
import ScheduleChart from '@client/pages/schedule-plan/components/chart/index.vue';
import canenderMixin from '@client/pages/personal/schedule/calender/mixins';
import { mapActions, mapState } from 'pinia';
import { scheduleStore } from '@client/store/scheduleStore';
import { userStore } from '@client/store/userStore';
import { initStore } from '@client/store/initStore';
import TrainingEdit from '@client/components/trainingEdit/index.vue';
import ProgramEdit from '@client/components/programEdit/index.vue';
import SkeletonPage from '../components/skeletonPage/index.vue';
import { DEFAULT_FORM_DATA } from '../add/config';
import { training } from '@client/api';
import { getBaseConfigByRegion } from '@client/helper/http';
import useTempView from '@client/hooks/useTempView';

export default {
  name: 'schedulePlanShare',
  // eslint-disable-next-line vue/no-reserved-component-names,
  components: { Table, Textarea, ScheduleChart, Button, TrainingEdit, ProgramEdit, SkeletonPage },
  mixins: [canenderMixin],
  emits: ['fullfill'],
  setup() {
    const { isTempView } = useTempView();
    return { isTempView };
  },
  data: function () {
    return {
      loading: false,
      dataLoaded: false,
      showPlanModal: false,
      showProgramModal: false,
      trainingForm: cloneDeep(DEFAULT_FORM_DATA),
      program2edit: {},
      operateType: 'share',
      id: '',
      detail: {
        name: this.$t('N1117')
      },
      chartData: {
        firstDay: '',
        data: [],
        programs: []
      }
    };
  },
  computed: {
    ...mapState(userStore, ['unit', 'userId', 'accessToken']),
    ...mapState(initStore, ['regionId', 'CPL_Token', 'CPL_Region'])
  },
  watch: {
    // setup 里面的数据异步的，created 的时候还没好
    isTempView(val) {
      if (val) {
        this.getUser();
      }
    }
  },
  created() {
    // 获取已登录用户的区间数据
    if (this.CPL_Token || this.isTempView) {
      this.getUser();
    }
    this.getPublicProfile();
    const query = this.$route.query;
    const { planId: id, region, share } = query;
    this.id = id;
    this.getPlanDetail(id, region);
  },

  methods: {
    ...mapActions(userStore, ['initUserInfo']),
    ...mapActions(scheduleStore, [
      'fetchPlanDetail',
      'copyPlan',
      'updateActiveScheduleData',
      'updateScheduleModalOperateType',
      'updateCalendCardSportData',
      'updateCalendCardData'
    ]),
    ...mapActions(initStore, ['getPublicProfile']),
    async getUser() {
      const { CPL_Region } = this;
      const { teamapi: baseURL } = getBaseConfigByRegion(CPL_Region);
      await this.initUserInfo({
        options: {
          baseURL
        }
      });
      this.trainingForm.unit = this.unit;
    },
    getPlanDetail(id, region) {
      this.dataLoaded = false;
      this.fetchPlanDetail({
        supportRestExercise: 1,
        id,
        region
      }).then((res = {}) => {
        const { chartData } = this;
        let {
          startDay,
          endDay,
          entities = [],
          programs = [],
          sportDatasNotInPlan = [],
          eventTags = [],
          competitions = [],
          weekStages = [],
          maxIdInPlan,
          totalDay,
          name = '',
          overview = ''
        } = res;
        res.name = name || '';
        res.overview = overview || '';

        this.detail = res;
        startDay = startDay + '';
        endDay = endDay + '';
        this.firstDay = startDay;
        this.lastDay = endDay;
        this.dataLoaded = true;
        this.makeWeekSet(totalDay);
        this.preHandleShareWeekStage(weekStages);
        this.handleWeekData();
        this.handleScheduleData(programs);
        this.handleProgramsData(programs);
        this.preHandleEntriesData(entities);
        this.handleEntriesData(entities); // 处理entryies 类型数据

        this.chartData = {
          programs,
          data: this.chunkDays,
          firstDay: dayjs().format('YYYYMMDD')
        };
        // TODO share更新为 SSR方案
        // 更新页面head 标题和描述
        document.title = this.$t(name);
        const meta = document.getElementsByTagName('meta');
        meta['description'].setAttribute('content', this.$t(overview));
      });
    },
    makeWeekSet(totalDay) {
      const { mapDays } = this;
      const days = [];
      const weeks = Math.ceil(totalDay / 7);
      for (let i = 0; i < weeks; i++) {
        for (let j = 0; j < 7; j++) {
          const happenDay = dayjs()
            .add(i * 7 + j, 'days')
            .format('YYYYMMDD');
          mapDays[happenDay] = this.getShareDataForDay(i, j, happenDay);
        }
      }
      // 将mapDays 转换为days数组
      const daysSortArr = Object.keys(mapDays).sort();
      daysSortArr.forEach((happenDay) => {
        days.push(mapDays[happenDay]);
      });
      this.days = days;
      this.fullfillSportCard();
    },
    getShareDataForDay(weekIndex, dayIndex, happenDay) {
      const data = {
        happenDay,
        // date: day.format('D'),
        // day: day.format('d'),
        dateType: 'weekday',
        DATE: dayIndex === 0 ? this.$t(`R4008`, { OvO: weekIndex + 1 }) : null,
        type: 'share',
        putable: false,
        isBefore: false,
        isToday: false,
        sports: [],
        loading: false,
        popover: false
      };
      return data;
    },
    preHandleShareWeekStage(weekStages) {
      let { weekStagesData } = this;
      weekStages.forEach((item, weekIndex) => {
        let { weekNo } = item;
        const index = Number(weekNo) - 1;
        if (weekNo >= 0) {
          const firstDayInWeek = dayjs()
            .add(index * 7, 'days')
            .format('YYYYMMDD');
          weekStagesData[firstDayInWeek] = item;
        }
      });
    },
    preHandleEntriesData(entities) {
      entities.forEach((item) => {
        const { dayNo } = item;
        // 计算happenDay
        const weekIndex = Math.floor(dayNo / 7);
        const dayIndex = dayNo - weekIndex * 7;
        item.happenDay = dayjs()
          .add(weekIndex * 7 + dayIndex, 'days')
          .format('YYYYMMDD');
      });
    },
    //  保存计划到计划库
    importPlan() {
      const { CPL_Token, CPL_Region, id, regionId: region, detail } = this;
      if (!CPL_Token) {
        Modal.confirm({
          title: this.$t(`D1027`),
          okText: this.$t(`D1006`),
          cancelText: this.$t(`C1006`),
          titleAlign: 'start',
          modalClass: 'coros-modal-footer-right',
          onOk: () => {
            const lastUrl = this.$route.fullPath;
            window.location.href = `/login?lastUrl=${encodeURIComponent(lastUrl)}`;
          }
        });
        return;
      }
      if (this.loading) return;
      this.loading = true;
      // 跨服的话, 请改请求当前缓存信息里对应区域的域名
      // 请求取当前用户本地cookie的信息
      const { teamapi, hostname } = getBaseConfigByRegion(CPL_Region);

      const data = cloneDeep(detail);
      data.weekStages.forEach((week) => {
        delete week.firstDayInWeek;
      });
      // TODO: todo_climb 室内攀岩、抱石需要转难度
      // console.log(`data`, data);
      // data.programs.forEach((program) => {
      //   const flag = isIndoorClimbOrBoulderingTrainingSportType(program.sportType);
      //   if (flag) {
      //     program.exercises.forEach((exercise) => {
      //       console.log(`exercise`, exercise);
      //       // exercise.gradeSystem
      //     });
      //   }
      // });
      training
        .api4copyPlan({
          baseURL: teamapi,
          params: {
            id,
            region
          },
          data
        })
        .then(({ data }) => {
          this.loading = false;
          const res = data.value;
          Message.success({
            content: this.$t(`R9005`).toString(),
            onClose: () => {
              const { id: planId } = res;
              const url = `${hostname}/schedule-plan/edit?planId=${planId}&region=${CPL_Region}`;
              // location.href = `${hostname}/schedule-plan/edit?planId=${planId}&region=${CPL_Region}`;
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    handleOpenEditModal({ weekIndex, dayIndex, index }) {
      const dayItem = this.chunkDays[weekIndex][dayIndex];
      this.updateActiveScheduleData(dayItem);
      const { sports = [] } = dayItem;
      const { versionObjects } = this.trainingForm;
      // 数据项
      const item = sports[index];
      const { dataType } = item;
      const { name, id, planId, type, happenDay, program = {} } = item;
      const { sportType, overview = '' } = program;
      this.updateScheduleModalOperateType('edit');
      const entitie = cloneDeep(item);
      delete entitie.program;
      this.updateCalendCardSportData(entitie);
      this.updateCalendCardData({ weekIndex, dayIndex, index });
      this.operateType = 'edit';
      switch (dataType) {
        case 'training':
          // 组装数据,弹出modal
          this.trainingForm = {
            sportType,
            name,
            overview,
            id,
            planId,
            entities: [entitie],
            programs: [program],
            versionObjects
          };
          this.showPlanModal = true;
          break;
        case 'program':
          this.showProgramModal = true;
          if (!program.overview) program.overview = '';
          // @TODO 更新为从store里面取值
          this.program2edit = program;
          break;
        case 'label':
          // 组装数据,弹出modal
          this.planTagForm = {
            id,
            planId,
            type,
            name,
            happenDay
          };
          this.showPlanTagModal = true;
          break;
        default:
          break;
      }
    },
    handleSavePlan() {},
    handleCancel() {
      this.showPlanModal = false;
    },
    handleProgramModalChange() {}
  }
};
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';
.schedule-plan {
  .schedule-overview-textarea {
    .arco-textarea[disabled] {
      @apply text-white;
      -webkit-text-fill-color: #fff;
    }
  }
}
</style>
